import ProductItem from "gatsby-theme-dettol/src/components/common/ProductItem/ProductItem"

import "./ProductItemOverride.scss"

export default ProductItem